module.exports = __webpack_public_path__ + "static/media/epa-logo.93e9095d.png";